export enum TransactionType {
  Client = 'Client',
  Service = 'Service',
  ServiceMoneyFloat = 'ServiceMoneyFloat',
  ServiceEmptying = 'ServiceEmptying',
}
